/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLockOpen2 = createReactComponent("outline", "lock-open-2", "IconLockOpen2", [["path", { "d": "M3 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M13 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }]]);

export { IconLockOpen2 as default };
//# sourceMappingURL=IconLockOpen2.mjs.map
